import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Shop, ShopMovie } from '@digilize/shared/definitions/src';
import { SelectionOption } from '../form-items/select/select.component';

@Component({
  selector: 'lib-search-select',
  templateUrl: './search-select.component.html',
  styleUrls: ['./search-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SearchSelectComponent implements OnInit {
  @ViewChild(MatAutocompleteTrigger) autoComplete: MatAutocompleteTrigger;

  @Output() searchChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<any> = new EventEmitter<any>();

  @Input() shop: Shop;
  @Input() options: SelectionOption[];
  @Input() placeholder = 'global.search';
  @Input() btnLabel = 'global.select';
  @ContentChild('optionTemplate', { read: TemplateRef })
  optionTemplate?: TemplateRef<any>;

  selectedOption;
  searchControl = new FormControl();
  movies: ShopMovie[];
  dataLoaded = true;
  inputValue = '';

  constructor() {}

  ngOnInit() {}

  onValueChange(event) {
    this.inputValue = event.target.value;
    this.searchChange.emit(this.inputValue);
  }

  select(event, option: SelectionOption) {
    event.stopPropagation();
    this.itemSelected.emit(option);
  }

  optionClicked(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  resetValue(event) {
    event.stopPropagation();
    this.inputValue = '';
    this.searchChange.emit(this.inputValue);
  }
}
